import {
  statisticsIcenseIcon,
  // statisticsPackIcon,
  statisticsProfit2Icon,
  // statisticsProfit3Icon,
  statisticsProfit4Icon,
  statisticsProfitIcon,
  statisticsRef2Icon,
  statisticsRefIcon,
} from 'assets/images';

export const icons: { [key: string]: string } = {
  license_sales: statisticsIcenseIcon,
  // packages_sold: statisticsPackIcon,
  referrals_license_sales: statisticsRef2Icon,
  referrals_packages_sales_profit: statisticsRefIcon,
  personal_sales_profit: statisticsProfitIcon,
  referrals_sales_profit: statisticsProfit2Icon,
  // auto_bonus_profit: statisticsProfit3Icon,
  pools_profit: statisticsProfit4Icon,
};
